import { FormikCheckbox, FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Box } from 'grid'
import { SenderRecipientInsertType, SenderRecipientSetType } from 'model'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export type SenderRecipientValues =
  | SenderRecipientInsertType
  | SenderRecipientSetType
export class SenderRecipieltFormSchema {
  constructor() {
    return Yup.object().shape({
      supplierNumber: Yup.string()
        .required('Lieferantennummer darf nicht leer sein.')
        .length(
          10,
          'Lieferantennummer muss eine 10-Stellige Zahlenkombination sein. Führende Nullen sind erlaubt.'
        ),
      countryCode: Yup.string().length(
        2,
        'Länderkürzel sollte eine 2-Stellige Buchstabenkombination sein (z.B.: DE)'
      ),
      name: Yup.string().required(),
      place: Yup.string().required(),
      postCode: Yup.string().required(),
      street: Yup.string().required(),
    })
  }
}
export const SenderRecipientForm: React.FC = () => {
  const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="supplierNumber"
          label={t('field.supplierNumber.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="countryCode"
          label={t('field.countryCode.shortLabel')}
          component={FormikTextField}
        />
        <FieldStackItem
          name="name"
          label={t('field.name.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="place"
          label={t('field.place.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="postCode"
          label={t('field.postCode.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="street"
          label={t('field.street.label')}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          name="phone"
          label={t('field.phone.label')}
          component={FormikTextField}
        />
      </FieldStack>
      <FieldStack>
        <Box py={4}>
          <FieldStackItem
            stack={{ grow: 0 }}
            name="inactive"
            render={(fieldProps) => (
              <>
                <Label>{t('field.inactive.label')}</Label>
                <Box py={1}>
                  <FormikCheckbox {...fieldProps} />
                </Box>
              </>
            )}
          />
        </Box>
      </FieldStack>
    </FormStack>
  )
}
